import { z } from "zod";

const requiredErrorInput = { required_error: "入力してください" } as const;

export const editMasterDataVehicleFormSchema = z.object({
  number: z.string(requiredErrorInput),
  name: z.string().optional(),
  officeId: z.number().int().optional(),
  shape: z
    .enum([
      "other",
      "flat",
      "box",
      "hood",
      "dump",
      "semi_trailer",
      "full_trailer",
      "wing",
      "unic",
      "refrigerator",
      "freezer",
    ])
    .optional(),
  weightClass: z
    .union([
      z.literal(1),
      z.literal(2),
      z.literal(4),
      z.literal(10),
      z.literal(13),
      z.literal(20),
    ])
    .optional(),
  vehicleEquipments: z
    .array(
      z.enum([
        "air_suspension",
        "roller",
        "unic",
        "food",
        "wing",
        "power_gate",
      ]),
    )
    .optional(),
  memo: z.string().optional(),
});

export type EditMasterDataVehicleFormSchemaType = z.infer<
  typeof editMasterDataVehicleFormSchema
>;
